module.exports = __webpack_public_path__ + "img/_5.3c4fdc52.png";